import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { DateTimePicker } from "components/DatePicker/DateTimePicker";
import DepartAtArriveByDropdown from "components/dropdowns/reactselect/DepartAtArriveByDropdown";
import moment from "moment";
import React from "react";
import { GroundTransportDateTimeState } from "shared/utils/fieldsHelper/groundFields";
import { formatShortDateWithTime, formatWrittenDayMonth } from "utilities";
import { isEarlyShow } from "utilities/showDateUtils";

interface Props {
  value: GroundTransportDateTimeState
  onChange: (value: GroundTransportDateTimeState) => void
}

export const getInTheNightOfLabel = (dateTime: moment.Moment): string => {
  const inTheNightOfX = formatWrittenDayMonth(dateTime);
  const inTheNightOfY = formatShortDateWithTime(dateTime.clone().add(1, "day"));

  return RESX.DateTime.ThisAppointmentBeginsInTheNight
    .replace("{0}", inTheNightOfX)
    .replace("{1}", inTheNightOfY);
}

export const GroundTransportDateTime = (props: Props) => {
  const displayIsInTheNightOf = isEarlyShow(props.value.dateTime);

  return <div className="flex-column gap-small">
    <div className="flex align-center gap-small">
      <DepartAtArriveByDropdown
        value={props.value.departArrive}
        onChange={value => props.onChange({ ...props.value, departArrive: value })}
        options={[]}
      />
      <DateTimePicker
        value={props.value.dateTime}
        onChange={(value: moment.Moment) => {
          if (!isEarlyShow(value) && props.value.inTheNightOf) {
            props.onChange({ ...props.value, inTheNightOf: false });
          }
          props.onChange({ ...props.value, dateTime: value });
        }}
        validatorKey="newGroundTransportDateTime"
        minDate={moment.utc(serverReference.constants.appointment.minDate)}
        maxDate={moment.utc(serverReference.constants.appointment.maxDate)}
      />
      {displayIsInTheNightOf && <Checkbox
        label={RESX.DateTime.InTheNightOf}
        checked={props.value.inTheNightOf}
        onChange={(_, v) => props.onChange({ ...props.value, inTheNightOf: v })}
      />}
    </div>
    {props.value.inTheNightOf && <div dangerouslySetInnerHTML={{
      __html: getInTheNightOfLabel(props.value.dateTime),
    }} />}
  </div>
}